import React, { useCallback } from 'react';
import clsx from 'clsx';
import { useDropzone } from 'react-dropzone';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
    root: {},
    dragActive: {
        backgroundColor: theme.palette.action.active,
        opacity: 0.5,
    },
    image: {
        width: 130,
    },
    info: {
        marginTop: theme.spacing(1),
    },
    list: {
        maxHeight: 320,
    },
    actions: {
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'flex-end',
        '& > * + *': {
            marginLeft: theme.spacing(2),
        },
    },
}));

const FilesDropzone = ({
    customFunction,
    content,
    multiple = '',
    types,
    className = '',
    ...rest
}) => {
    const classes = useStyles();

    const handleDrop = useCallback((acceptedFiles) => {
        customFunction(acceptedFiles);
        //eslint-disable-next-line
    }, []);

    const { getRootProps, getInputProps } = useDropzone({
        onDrop: handleDrop,
        accept: types
            ? types
            : 'image/jpeg, image/png, application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,.csv,text/csv,application/msword,.doc,.docx,.Xsls',
    });

    return (
        <div className={clsx(classes.root, className)} {...rest}>
            <div {...getRootProps()}>
                <input {...getInputProps()} />
                {content}
            </div>
        </div>
    );
};

FilesDropzone.propTypes = {
    className: PropTypes.string,
};

export default FilesDropzone;
